import React from 'react';
import { FormInstance } from 'antd/es/form';
import { useRecoilState } from 'recoil';
import CompanyNameAndEmploymentType from 'components/community/parts/CompanyNameAndEmploymentType';
import InterviewDateSelector from 'components/community/parts/InterviewDateSelector';
import { makeLastNYearsList } from 'libs/utils';
import { TInterviewFirmInfo } from 'modules/community';
import { interviewFirmInfoState } from 'modules/community/recoilState';
import { CInterviewFinalResult } from 'constants/community.const';
import { EInterviewFinalResult } from 'enums/community.enum';
import { Form, Radio } from 'antd';
import styled from 'styled-components';
import { LightGrayColor, device } from 'GlobalStyles';

type TCompanyInformationProps = {
  form: FormInstance;
};

const CompanyInformationWrite = ({ form }: TCompanyInformationProps) => {
  const [interviewFirmInfo, setInterviewFirmInfo] = useRecoilState<TInterviewFirmInfo>(
    interviewFirmInfoState,
  );

  const onIsConsultingChange = (e: any) => {
    setInterviewFirmInfo({ ...interviewFirmInfo, isConsultingFirm: e.target.value });
  };

  const onInterviewResultChange = (e: any) => {
    setInterviewFirmInfo({ ...interviewFirmInfo, interviewResult: e.target.value });
  };

  return (
    <CompanyInformationWriteWrapper>
      {/* 선택되지 않은 부분 background 회색이 되게 하려면 상위태그에 className='form-normal' 하위에 className='form-item' */}
      <Form.Item
        className='form-item ' //initialValue 없애면서 form-item-fit-content 삭제
        name={'is_consulting_firm'}
        label={'컨설팅펌 여부'}
        // initialValue={isConsultingFirm}
        rules={[{ required: true }]}
      >
        {/* 'col-12' 는 각 radio width 50% */}
        <Radio.Group className='col-12' onChange={(e) => onIsConsultingChange(e)}>
          <Radio.Button value={true}>Yes</Radio.Button>
          <Radio.Button value={false}>No</Radio.Button>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        className='form-item ' //initialValue 없애면서 form-item-fit-content 삭제
        name={'interview_result'}
        label={'인터뷰 최종 결과'}
        style={{ marginBottom: '-15px' }} //initialValue 빼고 fit content 없애고 임시
        // initialValue={EInterviewFinalResult.Pass}
        rules={[{ required: true }]}
      >
        {/* 'col-8' 는 각 radio width 33.3% */}
        <Radio.Group className='col-8' onChange={(e) => onInterviewResultChange(e)}>
          {/* green - navy - red 순서 */}
          <Radio.Button className={`green-border`} value={EInterviewFinalResult.Pass}>
            {CInterviewFinalResult[EInterviewFinalResult.Pass]}
          </Radio.Button>
          <Radio.Button className={`navy-border`} value={EInterviewFinalResult.Proceeding}>
            {CInterviewFinalResult[EInterviewFinalResult.Proceeding]}
          </Radio.Button>
          <Radio.Button className={`red-border`} value={EInterviewFinalResult.Fail}>
            {CInterviewFinalResult[EInterviewFinalResult.Fail]}
          </Radio.Button>
        </Radio.Group>
      </Form.Item>
      <CompanyNameAndEmploymentType form={form} />
      <StyledInterviewDateContainer>
        <InterviewDateSelector lastNYearsList={makeLastNYearsList(4)} />
      </StyledInterviewDateContainer>
    </CompanyInformationWriteWrapper>
  );
};

//Radio color가 다른것은??

export default CompanyInformationWrite;

const CompanyInformationWriteWrapper = styled.div`
  /* 기업명 작성란 컬러 */
  & .ant-input {
    background: ${LightGrayColor} !important;
  }
`;

const StyledInterviewDateContainer = styled.div`
  width: 49%;
  @media screen and ${device.sm} {
    width: 100%;
  }
`;
